import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.string,
  link: PropTypes.string,
  icon: PropTypes.string,
});
